import { render, staticRenderFns } from "./Ambassador.vue?vue&type=template&id=2f53c56e"
import script from "./Ambassador.vue?vue&type=script&lang=js"
export * from "./Ambassador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports